import React, { useEffect, useMemo, useState } from "react";
import {
  Col, Row, Card, CardBody, Badge, Button, Spinner, Alert
} from "reactstrap";
import TableContainer from "../../../components/Common/TableContainer";
import Breadcrumbs from "../../../components/Common/Breadcrumb";

const BASE_URL = "https://harmanappapi.stechomeyazilim.info";

const getAuthHeaders = () => {
  const authUser = JSON.parse(localStorage.getItem("authUser") || "{}");
  const token = localStorage.getItem("token") || authUser?.Token;
  return {
    "Content-Type": "application/json",
    Authorization: `Bearer ${token}`,
  };
};

const MezatTeklifleri = () => {
  document.title = "Mezat Teklifleri | HarmanaGEL";

  const [teklifler, setTeklifler] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);

  const fetchTeklifler = async () => {
    setIsLoading(true);
    setError(null);
    try {
      const response = await fetch(
        `${BASE_URL}/MEZAT_TEKLIFLERI?$top=500&$orderby=TEKLIF_TARIHI desc&$expand=KULLANICILAR($select=AD_SOYAD,Mail_Adress),MEZATLAR($select=URUN_AD)`,
        { headers: getAuthHeaders() }
      );
      const result = await response.json();
      if (result && result.value) setTeklifler(result.value);
    } catch (err) {
      setError("Teklifler yüklenirken hata oluştu.");
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchTeklifler();
  }, []);

  const durumBadge = (durum) => {
    const renkler = { "Aktif": "success", "Pasif": "secondary", "Kazanan": "primary", "Kaybeden": "danger" };
    return <Badge color={renkler[durum] || "secondary"}>{durum || "-"}</Badge>;
  };

  const toplamTeklif = useMemo(() => teklifler.reduce((s, t) => s + parseFloat(t.TEKLIF_MIKTARI || 0), 0), [teklifler]);

  const columns = useMemo(() => [
    {
      header: "ID",
      accessorKey: "ID",
      enableSorting: true,
      enableColumnFilter: false,
      cell: (cell) => <span className="fw-bold">#{cell.getValue()}</span>,
    },
    {
      header: "Mezat",
      accessorKey: "MEZATLAR",
      enableSorting: false,
      enableColumnFilter: true,
      cell: (cell) => {
        const m = cell.getValue();
        return m ? <span className="fw-medium">{m.URUN_AD}</span> : <span className="text-muted">Mezat #{cell.row.original.MEZAT_ID}</span>;
      },
    },
    {
      header: "Teklif Veren",
      accessorKey: "KULLANICILAR",
      enableSorting: false,
      enableColumnFilter: true,
      cell: (cell) => {
        const u = cell.getValue();
        return u ? (
          <div>
            <div className="fw-medium">{u.AD_SOYAD}</div>
            <small className="text-muted">{u.Mail_Adress}</small>
          </div>
        ) : <span className="text-muted">Kullanıcı #{cell.row.original.KULLANICI_ID}</span>;
      },
    },
    {
      header: "Teklif Miktarı",
      accessorKey: "TEKLIF_MIKTARI",
      enableSorting: true,
      enableColumnFilter: false,
      cell: (cell) => (
        <span className="fw-bold text-success fs-5">
          {parseFloat(cell.getValue() || 0).toLocaleString("tr-TR", { minimumFractionDigits: 2 })} ₺
        </span>
      ),
    },
    {
      header: "Durum",
      accessorKey: "DURUM",
      enableSorting: true,
      enableColumnFilter: true,
      cell: (cell) => durumBadge(cell.getValue()),
    },
    {
      header: "Teklif Tarihi",
      accessorKey: "TEKLIF_TARIHI",
      enableSorting: true,
      enableColumnFilter: false,
      cell: (cell) => {
        const d = cell.getValue();
        return d ? new Date(d).toLocaleString("tr-TR") : "-";
      },
    },
  ], []);

  return (
    <React.Fragment>
      <div className="page-content">
        <div className="container-fluid">
          <Breadcrumbs title="HarmanaGEL" breadcrumbItem="Mezat Teklifleri" />

          {error && <Alert color="danger" toggle={() => setError(null)}>{error}</Alert>}

          <Row className="mb-3">
            <Col md={4}>
              <Card className="bg-primary text-white">
                <CardBody className="d-flex align-items-center gap-3">
                  <i className="bx bx-list-ul fs-1" />
                  <div>
                    <h5 className="mb-0">{teklifler.length}</h5>
                    <small>Toplam Teklif</small>
                  </div>
                </CardBody>
              </Card>
            </Col>
            <Col md={4}>
              <Card className="bg-success text-white">
                <CardBody className="d-flex align-items-center gap-3">
                  <i className="bx bx-money fs-1" />
                  <div>
                    <h5 className="mb-0">{toplamTeklif.toLocaleString("tr-TR", { minimumFractionDigits: 2 })} ₺</h5>
                    <small>Toplam Teklif Tutarı</small>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>

          <Row>
            <Col lg={12}>
              <Card>
                <CardBody>
                  <div className="d-flex justify-content-between align-items-center mb-3">
                    <h4 className="card-title mb-0">Mezat Teklifleri</h4>
                    <Button color="primary" size="sm" onClick={fetchTeklifler} disabled={isLoading}>
                      <i className="bx bx-refresh me-1" />
                      Yenile
                    </Button>
                  </div>

                  {isLoading ? (
                    <div className="text-center py-5"><Spinner color="primary" /></div>
                  ) : (
                    <TableContainer
                      columns={columns}
                      data={teklifler}
                      isGlobalFilter={true}
                      SearchPlaceholder="Teklif ara..."
                      isPagination={true}
                      isCustomPageSize={true}
                      tableClass="table-bordered align-middle nowrap w-100 mb-0"
                      theadClass="table-light"
                      paginationWrapper="dataTables_paginate paging_simple_numbers pagination-rounded"
                    />
                  )}
                </CardBody>
              </Card>
            </Col>
          </Row>
        </div>
      </div>
    </React.Fragment>
  );
};

export default MezatTeklifleri;
